"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputEmitter = exports.MessageType = exports.MouseButtonsState = exports.MouseButton = void 0;
const Log_1 = __importDefault(require("../Log"));
const StreamMessageController_1 = require("./StreamMessageController");
// Enums are ported from https://github.com/EpicGames/UnrealEngine/blob/6c20d9831a968ad3cb156442bebb41a883e62152/Engine/Source/Programs/PixelStreaming/WebServers/SignallingWebServer/scripts/app.js
// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
var MouseButton;
(function (MouseButton) {
    MouseButton[MouseButton["MainButton"] = 0] = "MainButton";
    MouseButton[MouseButton["AuxiliaryButton"] = 1] = "AuxiliaryButton";
    MouseButton[MouseButton["SecondaryButton"] = 2] = "SecondaryButton";
    MouseButton[MouseButton["FourthButton"] = 3] = "FourthButton";
    MouseButton[MouseButton["FifthButton"] = 4] = "FifthButton"; // Browser Forward button.
})(MouseButton = exports.MouseButton || (exports.MouseButton = {}));
var MouseButtonsState;
(function (MouseButtonsState) {
    MouseButtonsState[MouseButtonsState["PrimaryButton"] = 1] = "PrimaryButton";
    MouseButtonsState[MouseButtonsState["SecondaryButton"] = 2] = "SecondaryButton";
    MouseButtonsState[MouseButtonsState["PrimarySecondaryButton"] = 3] = "PrimarySecondaryButton";
    MouseButtonsState[MouseButtonsState["AuxiliaryButton"] = 4] = "AuxiliaryButton";
    MouseButtonsState[MouseButtonsState["PrimaryAuxilaryButton"] = 5] = "PrimaryAuxilaryButton";
    MouseButtonsState[MouseButtonsState["SecondaryAuxilaryButton"] = 6] = "SecondaryAuxilaryButton";
    MouseButtonsState[MouseButtonsState["FourthButton"] = 8] = "FourthButton";
    MouseButtonsState[MouseButtonsState["FifthButton"] = 16] = "FifthButton"; // 5th button (typically the "Browser Forward" button).
})(MouseButtonsState = exports.MouseButtonsState || (exports.MouseButtonsState = {}));
// Must be kept in sync with PixelStreamingProtocol::EToUE4Msg C++ enum.
var MessageType;
(function (MessageType) {
    /**********************************************************************/
    /*
     * Control Messages. Range = 0..49.
     */
    MessageType[MessageType["IFrameRequest"] = 0] = "IFrameRequest";
    MessageType[MessageType["RequestQualityControl"] = 1] = "RequestQualityControl";
    MessageType[MessageType["MaxFpsRequest"] = 2] = "MaxFpsRequest";
    MessageType[MessageType["AverageBitrateRequest"] = 3] = "AverageBitrateRequest";
    MessageType[MessageType["StartStreaming"] = 4] = "StartStreaming";
    MessageType[MessageType["StopStreaming"] = 5] = "StopStreaming";
    /**********************************************************************/
    /*
     * Input Messages. Range = 50..89.
     */
    // Generic Input Messages. Range = 50..59.
    MessageType[MessageType["UIInteraction"] = 50] = "UIInteraction";
    MessageType[MessageType["Command"] = 51] = "Command";
    // Keyboard Input Message. Range = 60..69.
    MessageType[MessageType["KeyDown"] = 60] = "KeyDown";
    MessageType[MessageType["KeyUp"] = 61] = "KeyUp";
    MessageType[MessageType["KeyPress"] = 62] = "KeyPress";
    // Mouse Input Messages. Range = 70..79.
    MessageType[MessageType["MouseEnter"] = 70] = "MouseEnter";
    MessageType[MessageType["MouseLeave"] = 71] = "MouseLeave";
    MessageType[MessageType["MouseDown"] = 72] = "MouseDown";
    MessageType[MessageType["MouseUp"] = 73] = "MouseUp";
    MessageType[MessageType["MouseMove"] = 74] = "MouseMove";
    MessageType[MessageType["MouseWheel"] = 75] = "MouseWheel";
    // Touch Input Messages. Range = 80..89.
    MessageType[MessageType["TouchStart"] = 80] = "TouchStart";
    MessageType[MessageType["TouchEnd"] = 81] = "TouchEnd";
    MessageType[MessageType["TouchMove"] = 82] = "TouchMove";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var Action;
(function (Action) {
    Action["WindowResize"] = "1";
    Action["FreezeFrame"] = "pureweb.actions.v1.freeze";
    // Player Information and manipulation
    Action["PlayerInfoRequest"] = "pureweb.actions.v1.player_info_request";
    Action["PlayerInfoChangeRequest"] = "pureweb.actions.v1.player_info_change_request";
    // Participant creation and manipulation
    Action["ShowParticipants"] = "pureweb.actions.v1.participants_visibility_request";
    Action["CreateParticipantRequest"] = "pureweb.actions.v1.participant_create_request";
    Action["RemoveParticipantRequest"] = "pureweb.actions.v1.participant_remove_request";
    Action["ParticipantInfoRequest"] = "pureweb.actions.v1.participant_info_request";
    Action["ParticipantInfoChangeRequest"] = "pureweb.actions.v1.participant_change_request";
})(Action || (Action = {}));
// Must be kept in sync with JavaScriptKeyCodeToFKey C++ array. The index of the
// entry in the array is the special key code given below.
const SpecialKeyCodes = {
    BackSpace: 8,
    Shift: 16,
    Control: 17,
    Alt: 18,
    RightShift: 253,
    RightControl: 254,
    RightAlt: 255
};
// InputEmitter sends input events over a DataChannel packaged in an Unreal format.
// TODO: Wrap this in our own container format for extensibility reasons.
class InputEmitter {
    constructor(dataChannel, ueVersion) {
        this.m_fingers = [9, 8, 7, 6, 5, 4, 3, 2, 1, 0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.m_fingerIds = {};
        this.EmitRequestQualityControl = () => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const Data = new DataView(new ArrayBuffer(1));
            Data.setUint8(0, MessageType.RequestQualityControl);
            this.m_dc.send(Data);
        };
        this.NormalizeAndQuantizeUnsigned = (x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth) => {
            const viewPortAspectRatio = viewPortHeight / viewPortWidth;
            const streamAspectRatio = streamHeight / streamWidth;
            let normalizedX = 0;
            let normalizedY = 0;
            if (viewPortAspectRatio > streamAspectRatio) {
                const ratio = viewPortAspectRatio / streamAspectRatio;
                normalizedX = x / viewPortWidth;
                normalizedY = ratio * (y / viewPortHeight - 0.5) + 0.5;
            }
            else {
                const ratio = streamAspectRatio / viewPortAspectRatio;
                normalizedX = ratio * (x / viewPortWidth - 0.5) + 0.5;
                normalizedY = y / viewPortHeight;
            }
            if (normalizedX < 0.0 || normalizedX > 1.0 || normalizedY < 0.0 || normalizedY > 1.0) {
                return {
                    inRange: false,
                    x: 65535,
                    y: 65535
                };
            }
            else {
                return {
                    inRange: true,
                    x: normalizedX * 65536,
                    y: normalizedY * 65536
                };
            }
        };
        this.NormalizeAndQuantizeSigned = (x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth) => {
            const viewPortAspectRatio = viewPortHeight / viewPortWidth;
            const streamAspectRatio = streamHeight / streamWidth;
            let normalizedX = 0;
            let normalizedY = 0;
            if (viewPortAspectRatio > streamAspectRatio) {
                const ratio = viewPortAspectRatio / streamAspectRatio;
                normalizedX = x / (0.5 * viewPortWidth);
                normalizedY = (ratio * y) / (0.5 * viewPortHeight);
            }
            else {
                const ratio = streamAspectRatio / viewPortAspectRatio;
                normalizedX = (ratio * x) / (0.5 * viewPortWidth);
                normalizedY = y / (0.5 * viewPortHeight);
            }
            return {
                x: normalizedX * 32767,
                y: normalizedY * 32767
            };
        };
        this.EmitFreezeFrame = (bFreeze) => {
            const purewebFreezeMessage = {
                type: MessageType.UIInteraction,
                freeze: bFreeze,
                action: Action.FreezeFrame
            };
            this.EmitUIInteraction(purewebFreezeMessage);
        };
        this.EmitPositionRequest = (location, rotation) => {
            this.EmitPlayerInfoChangeRequest(location, rotation);
        };
        this.EmitPositionUpdateRequest = () => {
            this.EmitPlayerInfoRequest();
        };
        this.EmitPlayerInfoRequest = () => {
            const message = {
                type: MessageType.UIInteraction,
                action: Action.PlayerInfoRequest
            };
            this.EmitUIInteraction(message);
        };
        this.EmitPlayerInfoChangeRequest = (location, rotation) => {
            const message = {
                type: MessageType.UIInteraction,
                location,
                rotation,
                action: Action.PlayerInfoChangeRequest
            };
            this.EmitUIInteraction(message);
        };
        this.EmitShowParticipants = (visible) => {
            const message = {
                type: MessageType.UIInteraction,
                visible,
                action: Action.ShowParticipants
            };
            this.EmitUIInteraction(message);
        };
        this.EmitParticipantInfoRequest = () => {
            const message = {
                type: MessageType.UIInteraction,
                action: Action.ParticipantInfoRequest
            };
            this.EmitUIInteraction(message);
        };
        this.EmitParticipantInfoChangeRequest = (args) => {
            const { id, name, color, pointer, location, rotation } = args;
            const message = {
                type: MessageType.UIInteraction,
                id,
                name,
                color,
                pointer,
                location,
                rotation,
                action: Action.ParticipantInfoChangeRequest
            };
            this.EmitUIInteraction(message);
        };
        this.EmitCreateParticipantRequest = (args) => {
            const { id, name, color, location, rotation } = args;
            const message = {
                type: MessageType.UIInteraction,
                id,
                name,
                color,
                location,
                rotation,
                action: Action.CreateParticipantRequest
            };
            this.EmitUIInteraction(message);
        };
        this.EmitRemoveParticipantRequest = (id) => {
            const message = {
                type: MessageType.UIInteraction,
                id,
                action: Action.RemoveParticipantRequest
            };
            this.EmitUIInteraction(message);
        };
        this.EmitResize = (viewPortWidth, viewPortHeight) => {
            if (this.m_ueVersion === '5.0') {
                return;
            }
            const purewebResizeMessage = {
                type: MessageType.UIInteraction,
                width: viewPortWidth,
                height: viewPortHeight,
                action: Action.WindowResize
            };
            //This message will support games for UE version < 4.27 that are build with our plugin
            this.EmitUIInteraction(purewebResizeMessage);
        };
        this.EmitMessage = (messageType, descriptor) => {
            const message = {
                type: messageType,
                messagePayload: descriptor
            };
            this.EmitUIInteraction(message);
        };
        this.EmitMouseMove = (x, y, deltaX, deltaY, viewPortHeight, viewPortWidth, streamHeight, streamWidth) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const coord = this.NormalizeAndQuantizeUnsigned(x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            const delta = this.NormalizeAndQuantizeSigned(deltaX, deltaY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            const Data = new DataView(new ArrayBuffer(9));
            Data.setUint8(0, MessageType.MouseMove);
            Data.setUint16(1, coord.x, true);
            Data.setUint16(3, coord.y, true);
            Data.setInt16(5, delta.x, true);
            Data.setInt16(7, delta.y, true);
            this.m_dc.send(Data);
        };
        this.EmitMouseDown = (button, x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const coord = this.NormalizeAndQuantizeUnsigned(x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            const Data = new DataView(new ArrayBuffer(6));
            Data.setUint8(0, MessageType.MouseDown);
            Data.setUint8(1, button);
            Data.setUint16(2, coord.x, true);
            Data.setUint16(4, coord.y, true);
            this.m_dc.send(Data);
        };
        this.EmitMouseUp = (button, x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const coord = this.NormalizeAndQuantizeUnsigned(x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            const Data = new DataView(new ArrayBuffer(6));
            Data.setUint8(0, MessageType.MouseUp);
            Data.setUint8(1, button);
            Data.setUint16(2, coord.x, true);
            Data.setUint16(4, coord.y, true);
            this.m_dc.send(Data);
        };
        this.EmitMouseWheel = (delta, x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const coord = this.NormalizeAndQuantizeUnsigned(x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            const Data = new DataView(new ArrayBuffer(7));
            Data.setUint8(0, MessageType.MouseWheel);
            Data.setInt16(1, -1 * delta, true);
            Data.setUint16(3, coord.x, true);
            Data.setUint16(5, coord.y, true);
            this.m_dc.send(Data);
        };
        this.EmitTouchData = (type, touches, offsetLeft, offsetTop, viewPortHeight, viewPortWidth, streamHeight, streamWidth) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            if (type === MessageType.TouchStart) {
                for (let t = 0; t < touches.length; t++) {
                    this.rememberTouch(touches[t]);
                }
            }
            try {
                const Data = new DataView(new ArrayBuffer(2 + 7 * touches.length));
                Data.setUint8(0, type);
                Data.setUint8(1, touches.length);
                let byte = 2;
                for (let t = 0; t < touches.length; t++) {
                    const touch = touches[t];
                    const finger = this.m_fingerIds[touch.identifier];
                    if (finger === undefined) {
                        Log_1.default.error('Exceeded maximum number of available touch points (10)');
                        continue;
                    }
                    const x = touch.clientX - offsetLeft;
                    const y = touch.clientY - offsetTop;
                    // On iOS Safari, touch.force is not supported and always returns 0.
                    // Unreal requires a positive value otherwise the touch is ignored.
                    const force = touch.force === 0 && type !== MessageType.TouchEnd ? 1.0 : touch.force;
                    const coord = this.NormalizeAndQuantizeUnsigned(x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                    Data.setUint16(byte, coord.x, true);
                    byte += 2;
                    Data.setUint16(byte, coord.y, true);
                    byte += 2;
                    Data.setUint8(byte, finger);
                    byte += 1;
                    Data.setUint8(byte, 255 * force); // force is between 0.0 and 1.0 so quantize into byte.
                    byte += 1;
                    Data.setUint8(byte, coord.inRange ? 1 : 0); // inRange: 1 or 0
                    byte += 1;
                }
                this.m_dc.send(Data);
            }
            finally {
                if (type === MessageType.TouchEnd) {
                    for (let t = 0; t < touches.length; t++) {
                        this.forgetTouch(touches[t]);
                    }
                }
            }
        };
        this.EmitMouseEnter = () => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const Data = new DataView(new ArrayBuffer(1));
            Data.setUint8(0, MessageType.MouseEnter);
            this.m_dc.send(Data);
        };
        this.EmitMouseLeave = () => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const Data = new DataView(new ArrayBuffer(1));
            Data.setUint8(0, MessageType.MouseLeave);
            this.m_dc.send(Data);
        };
        this.filterKeyCode = (e) => {
            if (e.keyCode === SpecialKeyCodes.Shift && e.code === 'ShiftRight') {
                return SpecialKeyCodes.RightShift;
            }
            else if (e.keyCode === SpecialKeyCodes.Control && e.code === 'ControlRight') {
                return SpecialKeyCodes.RightControl;
            }
            else if (e.keyCode === SpecialKeyCodes.Alt && e.code === 'AltRight') {
                return SpecialKeyCodes.RightAlt;
            }
            else {
                return e.keyCode;
            }
        };
        this.rememberTouch = (touch) => {
            const finger = this.m_fingers.pop();
            if (finger === undefined) {
                Log_1.default.info('exhausted touch indentifiers');
            }
            this.m_fingerIds[touch.identifier] = finger;
        };
        this.forgetTouch = (touch) => {
            this.m_fingers.push(this.m_fingerIds[touch.identifier]);
            delete this.m_fingerIds[touch.identifier];
        };
        this.IsBrowserKey = (e) => {
            return (e.keyCode >= 112 && e.keyCode <= 123) || e.keyCode === 9;
        };
        this.EmitKeyUp = (e) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const Data = new DataView(new ArrayBuffer(2));
            Data.setUint8(0, MessageType.KeyUp);
            Data.setUint8(1, this.filterKeyCode(e));
            this.m_dc.send(Data);
        };
        this.EmitKeyDown = (e) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            if (e.keyCode === SpecialKeyCodes.BackSpace) {
                return this.EmitKeyPress(SpecialKeyCodes.BackSpace);
            }
            const Data = new DataView(new ArrayBuffer(3));
            Data.setUint8(0, MessageType.KeyDown);
            Data.setUint8(1, this.filterKeyCode(e));
            Data.setUint8(2, e.repeat ? 1 : 0);
            this.m_dc.send(Data);
        };
        this.EmitKeyPress = (charCode) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const Data = new DataView(new ArrayBuffer(3));
            Data.setUint8(0, MessageType.KeyPress);
            Data.setUint16(1, charCode, true);
            this.m_dc.send(Data);
        };
        this.EmitDescriptor = (type, descriptor) => {
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            const descriptorAsString = JSON.stringify(descriptor);
            const Data = new DataView(new ArrayBuffer(1 + 2 + 2 * descriptorAsString.length));
            let byteIdx = 0;
            Data.setUint8(byteIdx, type);
            byteIdx++;
            Data.setUint16(byteIdx, descriptorAsString.length, true);
            byteIdx += 2;
            for (let i = 0; i < descriptorAsString.length; i++) {
                Data.setUint16(byteIdx, descriptorAsString.charCodeAt(i), true);
                byteIdx += 2;
            }
            this.m_dc.send(Data.buffer);
        };
        this.EmitCommand = (descriptor) => {
            return this.EmitDescriptor(MessageType.Command, descriptor);
        };
        this.EmitUIInteraction = (descriptor) => {
            return this.EmitDescriptor(MessageType.UIInteraction, descriptor);
        };
        this.SendInputData = (buffer) => {
            this.m_dc.send(new Uint8Array(buffer));
        };
        this.sendMessageToStreamer = (messageType, messageData) => {
            if (messageData === undefined) {
                messageData = [];
            }
            const toStreamerMessages = this.streamMessageController.toStreamerMessages;
            const messageFormat = toStreamerMessages.getFromKey(messageType);
            if (messageFormat === undefined) {
                return;
            }
            const data = new DataView(new ArrayBuffer(messageFormat.byteLength + 1));
            data.setUint8(0, messageFormat.id);
            let byteOffset = 1;
            messageData.forEach((element, idx) => {
                const type = messageFormat.structure[idx];
                switch (type) {
                    case 'uint8':
                        data.setUint8(byteOffset, element);
                        byteOffset += 1;
                        break;
                    case 'uint16':
                        data.setUint16(byteOffset, element, true);
                        byteOffset += 2;
                        break;
                    case 'int16':
                        data.setInt16(byteOffset, element, true);
                        byteOffset += 2;
                        break;
                    case 'float':
                        data.setFloat32(byteOffset, element, true);
                        byteOffset += 4;
                        break;
                    case 'double':
                        data.setFloat64(byteOffset, element, true);
                        byteOffset += 8;
                        break;
                }
            });
            if (!this.m_dc || this.m_dc.readyState !== 'open') {
                return;
            }
            else {
                this.m_dc.send(data.buffer);
            }
        };
        this.m_dc = dataChannel;
        this.m_ueVersion = ueVersion;
        this.EmitMouseEnter();
        // this one is only for 4.27
        this.EmitRequestQualityControl();
        this.streamMessageController = new StreamMessageController_1.StreamMessageController();
        this.streamMessageController.populateDefaultProtocol();
    }
}
exports.InputEmitter = InputEmitter;
